import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@platform/state/hooks';
import { selectDialog } from '@platform/state/selectors';
import { dialogClosed } from '@platform/state/slices/uiSlice';
import type { INewRecordDialogProps } from '../INewRecordDialogProps';
import { useOpenNewRecord } from './useOpenNewRecord';

/**
 * Запуск створення запису з кнопок «+ Створити …» панелі таблиці, «+ Нове …» меню модуля й «+» доріжки дошки (подія dialogOpened
 * newRecord): замість діалогу відкривається повна форма нового запису в режимі редагування (прототип v4) з наперед заданими значеннями.
 * Один запит — один перехід (повторний запуск ефекту, напр. у StrictMode, його не повторює).
 */
export function NewRecordLauncher({ ws, module, rt, initialValues, scope }: INewRecordDialogProps) {
  const dispatch = useAppDispatch();
  const dialog = useAppSelector(selectDialog);
  const openNew = useOpenNewRecord();
  const handled = useRef(false);
  const requested = dialog.kind === 'newRecord' && dialog.recordType === rt.key && (dialog.recordId ?? '') === (scope ?? '');
  useEffect(() => {
    if (!requested) { handled.current = false; return; }
    if (handled.current) return;
    handled.current = true;
    dispatch(dialogClosed());
    openNew(module.module.key, rt.key, initialValues);
  }, [requested, dispatch, openNew, ws, module.module.key, rt.key, initialValues]);
  return null;
}
